import { z } from "zod";

export const LISTING_FILTERS = [
    "all",
    "available",
    "pending",
    "needs_photos",
    "draft",
    "adopted",
] as const;

export const kennelListingsSearchSchema = z.object({
    filter: z.enum(LISTING_FILTERS).optional().catch(undefined),
    page: z.coerce.number().int().min(1).optional().catch(undefined),
    q: z
        .union([z.string(), z.number()])
        .transform(String)
        .optional()
        .catch(undefined),
});

export type KennelListingsSearch = z.infer<typeof kennelListingsSearchSchema>;
